/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import angular from 'angular';
import {
    crsUpdateEventDetailsComponentOptions,
} from './components';

const eventsModule = angular.module('avi/events');

const components = [
    {
        name: 'crsUpdateEventDetails',
        options: crsUpdateEventDetailsComponentOptions,
    },
];

components.forEach(({ name, options }) => eventsModule.component(name, options));
